import { Controller } from "@hotwired/stimulus";
import { attachSummernote } from '../../scripts/summernoteHelper';
import { DomEvents } from "../_generated/DomEvents";

export default class DetailBasicInformationController extends Controller {
    static targets = [
        "description"
    ];

    readonly descriptionTarget!: HTMLElement;

    connect() {
        const descriptionTarget = $(this.descriptionTarget);
        attachSummernote(descriptionTarget);

        this.dispatch(DomEvents.tourDetailBasicInformationLoaded);
    }
}